const baseURL = `${process.env.REACT_APP_BASE_URL}/api`;

const headers = {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
};

// Send intergation checker email
const SendCheckerIntergateEmailApi = async (
    accessToken: string, // access token
    email: string, // email
    langCode: string, // language code
    backgroundColor?: string, // Background Color
    title?:string,
    style?:string,
): Promise<any> => {

    const url = `${baseURL}/checker/integration-request`;
    const data = new FormData();

    data.append("email", email);
    data.append("langcode", langCode);
    data.append("is_white_label", "true");
    backgroundColor && data.append("background_color", backgroundColor);
    title && data.append("title", title);
    style && data.append("style", style);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

const CheckStatusCheckerIntergateEmailApi = async (
    PID: string, // access token
): Promise<any> => {

    const url = `${baseURL}/checker/integration-request-status`;

    const data = new FormData();

    data.append("user_id", PID);
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
            },
            body: data
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

// Edit intergation checker email
const EditCheckerIntergateEmailApi = async (
    accessToken: string, // access token
    email: string, // email
    id: string, // language code,
    backgroundColor?: string, // Background Color
    title?:string,
    style?:string,
): Promise<any> => {

    const url = `${baseURL}/checker/integration-request-edit`;
    const data = new FormData();

    data.append("email", email);
    data.append("id", id);
    backgroundColor && data.append("background_color", backgroundColor);
    title && data.append("title", title);
    style && data.append("style", style);

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                ...headers,
                "Authorization": "Bearer " + accessToken
            },
            body: data,
        });
        return await response.json();
    } catch (error) {
        return Promise.reject;
    }
}

export {SendCheckerIntergateEmailApi, CheckStatusCheckerIntergateEmailApi, EditCheckerIntergateEmailApi}